module.exports = __webpack_public_path__ + "media/images/pic/brodno/hero_brodno_teenagers-6f17d6338c080af696e20e0b67334720.svg";